import { authHeader } from './auth-header'
import axios from '../../axios'
import store from '../../state/store'

export const userService = {
  login,
  fetchUser,
  logout,
  requestToken,
  checkMobileIsUnique,
  verifyToken,
  register,
  getAll,
  updateUserDetail,
  updateUserMobile,
  updateUserPassword,
  forgotPassword,
  resetPassword,
}

function login(username, password) {
  return new Promise((resolve, reject) => {
    let route = 'auth/login'

    let data = {
      username: username,
      emial: username,
      password: password,
    }

    axios
      .post(route, data)
      .then((res) => {
        window.localStorage.setItem('user', JSON.stringify(res.data.user))
        window.localStorage.setItem('access_token', res.data.access_token)
        store.commit('auth/SET_CURRENT_USER', res.data.user)
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function updateUserDetail(payload) {
  return new Promise((resolve, reject) => {
    let route = 'auth/update-user-detail'
    axios
      .post(route, payload)
      .then((res) => {
        window.localStorage.setItem('user', JSON.stringify(res.data.user))
        window.localStorage.setItem('access_token', res.data.access_token)
        store.commit('auth/SET_CURRENT_USER', res.data.user)
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function updateUserMobile(payload) {
  return new Promise((resolve, reject) => {
    let route = 'auth/update-user-mobile'
    axios
      .post(route, payload)
      .then((res) => {
        window.localStorage.setItem('user', JSON.stringify(res.data.user))
        window.localStorage.setItem('access_token', res.data.access_token)
        store.commit('auth/SET_CURRENT_USER', res.data.user)
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function updateUserPassword(payload) {
  return new Promise((resolve, reject) => {
    let route = 'auth/update-user-password'

    axios
      .post(route, payload)
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function forgotPassword(email) {
  return new Promise((resolve, reject) => {
    let route = 'auth/forgot-password'

    axios
      .post(route, { email: email })
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function resetPassword(payload) {
  return new Promise((resolve, reject) => {
    let route = 'auth/reset-password'

    axios
      .post(route, payload)
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function fetchUser() {
  return new Promise((resolve, reject) => {
    let route = 'auth/user'
    axios
      .get(route, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            'access_token'
          )}`,
        },
      })
      .then((res) => {
        window.localStorage.setItem('user', JSON.stringify(res.data.user))
        window.localStorage.setItem('access_token', res.data.access_token)
        store.commit('auth/SET_CURRENT_USER', res.data.user)
        resolve(res)
      })
      .catch((er) => {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('access_token')
        reject(er)
      })
  })
}

function logout() {
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('access_token')
  window.location.href = '/login'
}

function requestToken(mobile, tokenable) {
  let route
  switch (tokenable) {
    case 'register':
      route = 'auth/register/request-token'
      break
    case 'reset_password':
      route = 'auth/reset-password/request-token'
      break
    case 'update_mobile':
      route = 'auth/update-user-mobile/request-token'
      break
    default:
      route = 'auth/request-token'
  }

  return new Promise((resolve, reject) => {
    axios
      .post(route, { mobile: mobile })
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function verifyToken(payload, tokenable) {
  return new Promise((resolve, reject) => {
    let route
    switch (tokenable) {
      case 'register':
        route = 'auth/register/verify-token'
        break
      case 'reset_password':
        route = 'auth/reset-password/verify-token'
        break
      default:
        route = 'auth/verify-token'
    }
    axios
      .post(route, payload)
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function checkMobileIsUnique(mobile) {
  return new Promise((resolve, reject) => {
    let route = 'auth/check-mobile-is-unique'
    axios
      .post(route, { phoneno: mobile })
      .then((res) => {
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function register(payload) {
  return new Promise((resolve, reject) => {
    axios
      .post('auth/register', payload)
      .then((res) => {
        window.localStorage.setItem('user', JSON.stringify(res.data.user))
        window.localStorage.setItem('access_token', res.data.access_token)
        store.commit('auth/SET_CURRENT_USER', res.data.user)
        resolve(res)
      })
      .catch((er) => {
        reject(er)
      })
  })
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return fetch(`/users`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        location.reload(true)
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
